import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import EditOppPlayerOverlay from './EditOppPlayer';


const OppPlayerCard = ({ v, onSelectPlayer }) => {
  return (
    <div className="detail-card">
      <div className="player-data-row" onClick={() => onSelectPlayer(v)}>
        <span className="homejer">{v.playerNumber}</span>
        <span className="player-txt" title={v.playerName}>
          {v.playerName}
        </span>
        {v.isCaptain === "true" && <span className="star-icon">*</span>}
        <span className="homejer">{v.position || "-"}</span>
      </div>
    </div>
  );
};

export default OppPlayerCard;

